export default "__VITE_ASSET__d753989d__"